import {
  CreateCargoClaimCommand,
} from "@amzn/ttechclaimintakeservice-client";

import { getAuthenticatedClient } from "../setup/getAuthenticatedClient";
import { MetricsPublisher } from "../../metrics/metrics";
import { ProcessedApiResponse } from "../types";
import { createCargoClaimModelBuilder } from "./CargoClaimModelBuilder";
import { FormStateType } from "src/forms/types";
import { CargoClaimAdditionalFields } from "src/app/Cargo/types";

export async function createCargoClaimService(
  formState: FormStateType, additionalFields: CargoClaimAdditionalFields
) {
  const { client } = await getAuthenticatedClient();
  if (!client) {
    return null;
  }

  const commandInput =
          createCargoClaimModelBuilder(formState, additionalFields);
  const command = new CreateCargoClaimCommand(commandInput);
  const metricsPublisher = new MetricsPublisher("api.createCargoClaim");

  return await client
    .send(command)
    .then((response: any) => {
      const statusCode = response?.$metadata?.httpStatusCode?.toString();
      const processedResponse: ProcessedApiResponse = {
        statusCode,
        warningList: response.warningList,
        data: [
          {
            fieldName: "Claim Reference Number",
            fieldValue: response.claimNumber,
          },
        ],
      };
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderSuccessMetrics();
      return processedResponse;
    })
    .catch((error: any) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderFatalMetrics();
      throw error;
    });
}
